const isoDate = (value: Date): string => value.toLocaleDateString('en-CA');

export function defaultDateFrom(): string {
  const today = new Date();
  return isoDate(new Date(today.getFullYear(), today.getMonth(), 1));
}

export function defaultDateTo(): string {
  return isoDate(new Date());
}
